<div
  class="tag"
  [class.info]="type() === 'info'"
  [class.neutral]="type() === 'neutral'"
  [class.warning]="type() === 'warning'"
  [class.error]="type() === 'error'"
  [class.success]="type() === 'success'"
  [class.brand]="type() === 'brand'"
  [class.emphasized]="emphasized()"
>
  <ng-content></ng-content>
</div>
